import { render } from "./UserVariables.vue?vue&type=template&id=a46868a2"
import script from "./UserVariables.vue?vue&type=script&lang=js"
export * from "./UserVariables.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__